/**
 * Created by mauricio on 5/12/15.
 */
'use strict'
module.exports = function (Interval) {
  return {
    disableRounding: function () {
      Interval.rmath.disable()
    },

    enableRounding: function () {
      Interval.rmath.enable()
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/interval-arithmetic-eval/lib/policies.js
// module id = ATEb
// module chunks = 0